import type { InviteDto } from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useUpdateInvite() {
	return useMutation({
		mutationKey: ["invites"],
		mutationFn: async (
			payload: { inviteCode: string } & Pick<InviteDto, "accepted">,
		) => {
			const response = await fetch(
				`${SERVICE_API}/api/invites/${payload.inviteCode}`,
				{
					method: "POST",
					credentials: "include",
					body: JSON.stringify({
						accepted: payload.accepted,
					}),
					headers: {
						"Content-Type": "application/json",
					},
				},
			);

			if (!response.ok) {
				throw new Error("Failed to update invite");
			}

			return response;
		},
		onSuccess: (_, __, ___, c) => {
			c.client.invalidateQueries({
				queryKey: ["invites"],
			});
		},
	});
}
